import React from 'react';
import { Link } from 'react-router-dom';


const Portfolio = () => {
  return (
    <section className="portfolio" id="portfolio">
      <header className="text-center">
        <h2><span className="index">02</span> PORTFOLIO</h2>
        <p className="d-flex justify-content-center align-items-center">MY LATEST WORK.
            <Link to="/portfolio" className="d-flex align-items-center ml-3">SEE MORE <i className="fal fa-angle-double-right h2 m-0 ml-3"></i></Link>
        </p>
      </header>
      <main className="container">
        <div className="row justify-content-center">
          <Link to="/portfolio" className="p-0 col-sm-4 col-md-3">
            <img src="images/bulletin_board.png" alt="" width="100%" />
          </Link>
          <Link to="/portfolio" className="p-0 col-sm-4 col-md-3">
            <img src="images/dashboard.png" alt="" width="100%" />
          </Link>
          <Link to="/portfolio" className="p-0 col-sm-4 col-md-3">
            <img src="images/camper.png" alt="" width="100%" />
          </Link>
        </div>
      </main>
    </section>
  );
}

export default Portfolio;
